import React, { useState, useEffect, useContext } from "react";
import loaderGif from "../../src/Images/images/loader.gif";
import Nabvar from "./Navbar";
import Footer from "./footer";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdOutlineDateRange } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import Blog from "./Blogs";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import { basicauthblog } from "../Utils/Credentials";
const Slug = () => {
  const { password, username } = basicauthblog;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const [blogData, setBlogData] = useState(null);
  const [postdata, setpostdata] = useState([]);
  const { post_slug } = useParams();
  useEffect(() => {
    console.log(post_slug);
    if (post_slug) {
      GetAuthorsBlog(post_slug);
    }
  }, [post_slug]);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const tags = [
    "Business",
    "Corporate",
    "Finance",
    "Invest",
    "Planning",
    "Sport",
    "News",
  ];
  const GetAuthorsBlog = async (slug) => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ slug: slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        setBlogData(data.data[0]);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const Getproductblogs = async () => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          webid: "2",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    if (blogData) {
      const images = document.querySelectorAll(".blog-content img");
      images.forEach((img) => {
        img.style.borderRadius = "1rem";
        img.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
        img.style.width = "100%";
        img.style.height = "auto";
      });
    }
  }, [blogData]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  if (!blogData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ height: "100vh" }} />
      </div>
    );
  }
  function cleanBlockContent(htmlString) {
    return htmlString
      .replace(/<\/?span[^>]*>/g, "")
      .replace(/ style="[^"]*"/g, "") // removes inline styles
      .replace(/&nbsp;/g, " ") // replace non-breaking spaces
      .trim();
  }

  return (
    <>
      <Helmet>
        {/* SEO Meta Tags */}
        <title>{blogData.title}</title>
        <meta name="description" content={blogData.excerpt} />
        <meta name="keywords" content={blogData.keyword} />
        <link
          rel="canonical"
          href={`https://billpunch.com/blog/${post_slug}`}
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.excerpt} />
        <meta property="og:image" content={blogData.image_url} />
        <meta
          property="og:url"
          content={`https://billpunch.com/blog/${post_slug}`}
        />
        <meta property="og:type" content="article" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.excerpt} />
        <meta name="twitter:image" content={blogData.image_url} />
        {/* <script type="application/ld+json">{blogData.schema_json}</script> */}
      </Helmet>

      <Nabvar />

      <div className="row mt-4">
        <div className="col-md-1"></div>
        <div className="col-10 m-md-0 m-3">
          <div className="row " style={{ height: "auto" }}>
            <div
              className="col-md-9 col-12 m-0 p-0 "
              style={{
                // height: "120vh",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <style>
                {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
              </style>
              <div style={{ width: "90%" }}>
                <div className="d-flex flex-wrap"></div>

                <h1>{blogData.title}</h1>

                <div className="row">
                  <p
                    className="col"
                    style={{
                      fontSize: ".9rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {blogData.author_url ? (
                      <img
                        src={blogData.author_url}
                        alt={blogData.author_url}
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginRight: "8px",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "inline-block";
                        }}
                      />
                    ) : (
                      <FaUserTie
                        style={{
                          fontSize: "1.3rem",
                          color: "grey",
                          marginRight: "8px",
                        }}
                      />
                    )}

                    <FaUserTie
                      style={{
                        fontSize: "1.3rem",
                        color: "grey",
                        marginRight: "8px",
                        display: "none",
                      }}
                    />

                    <Link
                      to={`/author/${blogData.author_slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                      onClick={() => {
                        const authorData = JSON.stringify(blogData);
                        console.log("click hua");
                        localStorage.setItem("author", authorData);
                      }}
                    >
                      {blogData.author_name}
                    </Link>
                  </p>

                  <p
                    className="col d-flex justify-content-end p-0"
                    style={{ fontSize: ".9rem" }}
                  >
                    <MdOutlineDateRange
                      style={{ fontSize: "1.3rem", color: "grey" }}
                    />
                    &nbsp;
                  </p>
                </div>

                <div>
                  <img
                    src={blogData.image_url}
                    alt={blogData.image_desc}
                    title={blogData.image_desc}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "1rem",
                    }}
                  />
                </div>

                <p className="pt-4" style={{ fontSize: "1rem" }}>
                  {blogData.excerpt}
                </p>

                <div className="blog-content mt-3">
                <style>
  {`
    .blog-content a {
      text-decoration: none;
    }

    .blog-content a:hover {
      text-decoration: underline;
    }

    .blog-content blockquote {
      border-left: 4px solid #ccc;
      margin: 1em 0;
      padding: 0.75em 1em;
      background: #f9f9f9;
      font-style: italic;
      color: #555;
    }

    .blog-content blockquote p {
      margin: 0;
    }
  `}
</style>


                          {(() => {
                            const renderedContents = new Set();

                            return blogData.blocks?.map((block, index) => {
                              const cleanedContent = cleanBlockContent(
                                block.block_content
                              );
                              const type = block.block_type.toLowerCase();

                              if (
                                (type === "ul" || type === "ol") &&
                                cleanedContent
                              ) {
                                const tempDiv = document.createElement("div");
                                tempDiv.innerHTML = cleanedContent;
                                const paragraphs = Array.from(
                                  tempDiv.querySelectorAll("p")
                                );
                                paragraphs.forEach((p) =>
                                  renderedContents.add(p.innerHTML.trim())
                                );
                              }

                              if (
                                type === "p" &&
                                renderedContents.has(cleanedContent.trim())
                              ) {
                                return null;
                              }

                              const supportedTags = [
                                "h1",
                                "h2",
                                "h3",
                                "h4",
                                "h5",
                                "h6",
                                "p",
                                "ul",
                                "ol",
                                "li",
                                "blockquote",
                                "code",
                                "pre",
                                "div",
                                "span",
                                "strong",
                                "em",
                                "u",
                                "img",
                                "video",
                                "a",
                                "br",
                              ];

                              if (
                                (type === "p" || type.startsWith("h")) &&
                                cleanedContent.includes("<img") &&
                                blogData.blocks[
                                  index + 1
                                ]?.block_type.toLowerCase() === "img"
                              ) {
                                const nextImg =
                                  blogData.blocks[index + 1].block_image;
                                const match = cleanedContent.match(
                                  /<img[^>]+src="([^"]+)"/i
                                );
                                if (match && match[1] === nextImg) return null;
                              }

                              if (type === "img" && block.block_image) {
                                return (
                                  <div key={index} className="my-3 text-center">
                                    <img
                                      src={block.block_image}
                                      alt={block.block_image_alt || ""}
                                      title={block.block_image_title || ""}
                                      className="img-fluid"
                                      style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                      }}
                                    />
                                    {block.block_image_desc && (
                                      <p
                                        className="mt-2 text-muted"
                                        style={{ fontStyle: "" }}
                                      >
                                        {block.block_image_desc}
                                      </p>
                                    )}
                                  </div>
                                );
                              }

                              if (supportedTags.includes(type)) {
                                return (
                                  <div
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: `<${type}>${cleanedContent}</${type}>`,
                                    }}
                                  />
                                );
                              }

                              return (
                                <p
                                  key={index}
                                  dangerouslySetInnerHTML={{
                                    __html: cleanedContent,
                                  }}
                                />
                              );
                            });
                          })()}
                        </div>

                <div className="mb-2">
                  {[
                    ...(blogData.keyword || "").split(","),
                    // ...(blogData.tag || "").split(","),
                  ].map(
                    (keyword, index) =>
                      keyword.trim() && (
                        <span
                          key={index}
                          className="me-2 mb-2 d-inline-block"
                          style={{
                            backgroundColor: "#f0f0f0",
                            border: "1px solid #b0b0b0",
                            color: "#333",
                            borderRadius: ".2rem",
                            fontSize: ".8rem",
                            padding: "0.25rem 0.5rem",
                            marginLeft: ".4rem",
                          }}
                        >
                          {keyword.trim()}
                        </span>
                      )
                  )}
                </div>
                <div className="mb-4 px-2">
                  {(blogData.tag || "")
                    .split(",")
                    .filter((tag) => tag.trim())
                    .map((tag, index) => (
                      <a
                        key={index}
                        href={`https://www.google.com/search?q=${encodeURIComponent(
                          tag.trim()
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-2 mb d-inline-block text-decoration-none px-2"
                      >
                        #{tag.trim()}
                      </a>
                    ))}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-12 p-md-0 p-5">
              <h6 className="mt-3 text-center">Related Blogs</h6>

              {/* Scrollable container */}
              <div
                className="related-blogs-scroll mt-5"
                style={{
                  maxHeight: "100vh",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
              >
                {postdata.map((blog) => (
                  <div
                    key={blog.id}
                    className="d-flex align-items-center mb-3"
                    style={{ width: "100%" }}
                  >
                    <img
                      src={blog.image_url}
                      alt={blog.image_alt || "Blog Image"}
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        marginRight: "1rem",
                        flexShrink: 0,
                      }}
                    />

                    <Link
                      to={`/blog/${blog.slug}`}
                      onClick={() => {
                        sessionStorage.setItem("Slug", JSON.stringify(blog));
                      }}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "start" }}>
                        <p
                          className="mb-2"
                          style={{
                            fontSize: ".8rem",
                            margin: 0,
                            color: "black",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {(() => {
                            const words = blog.title.split(" ");
                            const line1 = words.slice(0, 6).join(" ");
                            const line2 = words.slice(6, 13).join(" ");
                            return line2 ? `${line1} ${line2}...` : line1;
                          })()}
                        </p>

                        <p
                          style={{
                            fontSize: ".8rem",
                            color: "#686D76",
                            margin: 0,
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {blog.author_image ? (
                            <img
                              src={blog.author_image}
                              alt={blog.author_name}
                              style={{
                                width: "18px",
                                height: "18px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                marginRight: "6px",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display =
                                  "inline-block";
                              }}
                            />
                          ) : (
                            <FaUserTie
                              style={{
                                fontSize: ".9rem",
                                color: "grey",
                                marginRight: "6px",
                              }}
                            />
                          )}
                          <span
                            style={{
                              display: blog.author_image
                                ? "inline"
                                : "inline-block",
                            }}
                          >
                            {blog.author_name}
                          </span>
                        </p>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>

              {/* Hide scrollbar CSS */}
              <style>
                {`
      .related-blogs-scroll::-webkit-scrollbar {
        display: none;
      }
      .related-blogs-scroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }
    `}
              </style>
            </div>
          </div>
          {/* <Blog/> */}
        </div>
        <div className="col-md-1"></div>
      </div>
      <Footer />
    </>
  );
};

export default Slug;
